import { render } from "./UserCompanyLists.vue?vue&type=template&id=3c656b47"
import script from "./UserCompanyLists.vue?vue&type=script&lang=js"
export * from "./UserCompanyLists.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__